<svg class="chart" id="chart" overflow="scroll" preserveAspectRatio="xMidYMid meet">
  <defs>
    <!-- MILLIMETER PAPER PATTERN -->
    <pattern height="10" id="paper" patternUnits="userSpaceOnUse" width="10" x="0" y="0">
      <line stroke="red" stroke-width="0.5" x1="0" x2="0" y1="0" y2="10" />
      <line [attr.transform]="'translate(0.1, 0)'" stroke="red" stroke-width="0.1" x1="1" x2="1.0001" y1="0" y2="10" />
      <line [attr.transform]="'translate(0.1, 0)'" stroke="red" stroke-width="0.1" x1="2" x2="2.0001" y1="0" y2="10" />
      <line [attr.transform]="'translate(0.1, 0)'" stroke="red" stroke-width="0.1" x1="3" x2="3.0001" y1="0" y2="10" />
      <line [attr.transform]="'translate(0.1, 0)'" stroke="red" stroke-width="0.1" x1="4" x2="4.0001" y1="0" y2="10" />

      <line [attr.transform]="'translate(0.1, 0)'" stroke="red" stroke-width="0.2" x1="5" x2="5.0001" y1="0" y2="10" />
      <line [attr.transform]="'translate(0.1, 0)'" stroke="red" stroke-width="0.1" x1="6" x2="6.0001" y1="0" y2="10" />
      <line [attr.transform]="'translate(0.1, 0)'" stroke="red" stroke-width="0.1" x1="7" x2="7.0001" y1="0" y2="10" />
      <line [attr.transform]="'translate(0.1, 0)'" stroke="red" stroke-width="0.1" x1="8" x2="8.0001" y1="0" y2="10" />
      <line [attr.transform]="'translate(0.1, 0)'" stroke="red" stroke-width="0.1" x1="9" x2="9.0001" y1="0" y2="10" />

      <line stroke="red" stroke-width="0.5" x1="0" x2="10" y1="0" y2="0" />
      <line [attr.transform]="'translate(0, 0.1)'" stroke="red" stroke-width="0.1" x1="0" x2="10" y1="1" y2="1.0001" />
      <line [attr.transform]="'translate(0, 0.1)'" stroke="red" stroke-width="0.1" x1="0" x2="10" y1="2" y2="2.0001" />
      <line [attr.transform]="'translate(0, 0.1)'" stroke="red" stroke-width="0.1" x1="0" x2="10" y1="3" y2="3.0001" />
      <line [attr.transform]="'translate(0, 0.1)'" stroke="red" stroke-width="0.1" x1="0" x2="10" y1="4" y2="4.0001" />

      <line [attr.transform]="'translate(0, 0.1)'" stroke="red" stroke-width="0.2" x1="0" x2="10" y1="5" y2="5.0001" />
      <line [attr.transform]="'translate(0, 0.1)'" stroke="red" stroke-width="0.1" x1="0" x2="10" y1="6" y2="6.0001" />
      <line [attr.transform]="'translate(0, 0.1)'" stroke="red" stroke-width="0.1" x1="0" x2="10" y1="7" y2="7.0001" />
      <line [attr.transform]="'translate(0, 0.1)'" stroke="red" stroke-width="0.1" x1="0" x2="10" y1="8" y2="8.0001" />
      <line [attr.transform]="'translate(0, 0.1)'" stroke="red" stroke-width="0.1" x1="0" x2="10" y1="9" y2="9.0001" />
    </pattern>
  </defs>

  <g [attr.transform]="chart?.transform" id="chartRoot">

    <rect [attr.opacity]="chart?.opacity" fill="url(#paper)" height="100%" width="100%" x="0"></rect>

    <g #centering [hideWhileCentering]="hideWhileCentering" layers-centering>
      <g (layoutChange)="centering.centerLayers()" *ngFor="let layer of chart?.layers"
        [arrangement]="arrangement$ | async"
        [layer]="layer"
        chart-layer></g>
    </g>
  </g>

  <text class="chart-title" x="50%" y="15">{{title}}</text>

</svg>

